import {Component, Input, OnInit} from '@angular/core';
import {FitMedProfile} from '@models/data/fit-med-profile/FitMedProfile';
import { FitMedProfileGender } from '@models/data/fit-med-profile/enums/FitMedProfileGender';
import { LocalizeTextPipe } from '@shared/pipes/localize-text/localize-text.pipe';
import { IconComponent } from '../icon/icon.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-gender',
    templateUrl: './gender.component.html',
    styleUrls: ['./gender.component.scss'],
    standalone: true,
    imports: [NgTemplateOutlet, IconComponent, LocalizeTextPipe]
})
export class GenderComponent implements OnInit {
  @Input() icon: boolean;
  @Input() name: boolean;

  @Input() height = 'h-3';
  @Input() width = 'w-3';

  fitMedProfileValue: FitMedProfile = null;
  gender = FitMedProfileGender;

  @Input() set fitMedProfile(content: FitMedProfile) {
    if (content && typeof content !== 'undefined') {
      this.fitMedProfileValue = content;
    }
  }
  constructor() { }

  ngOnInit(): void {
  }

}
